import {
    Component, Input, AfterViewInit, OnDestroy, ViewChild, ViewContainerRef,
    NgModule, Compiler, ComponentRef, ComponentFactoryResolver
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material';
import { VaultConnectionService } from '@src/services/VaultConnectionService.service';

@Component({
    selector: 'vault-connector',
    template: require('./vault-connection.component.html'),
    styles: []
})
export class VaultConnectionComponent implements AfterViewInit, OnDestroy {
    @Input() public component: any;
    @Input() public setData: (instance: any) => void;
    @Input() public compile = false;

    @ViewChild('container', { read: ViewContainerRef }) private container: ViewContainerRef;
    private componentRef: ComponentRef<any>;

    constructor(private compiler: Compiler, private resolver: ComponentFactoryResolver) {
    }

    public async ngAfterViewInit() {
        const factory = await this.getFactory();
        this.componentRef = this.container.createComponent(factory);

        const instance = this.componentRef.instance;
        this.setData(instance);
    }

    public ngOnDestroy() {
        if (this.componentRef) {
            this.componentRef.destroy();
        }
    }

    private async getFactory() {
        if (this.compile) {
            const module = NgModule({
                imports: [CommonModule, FormsModule, MatSelectModule],
                declarations: [this.component],
                providers: [VaultConnectionService]
            }
            )(class {});
            const factories = await this.compiler.compileModuleAndAllComponentsAsync(module);
            return factories.componentFactories[factories.componentFactories.length - 1];
        }
        return this.resolver.resolveComponentFactory(this.component);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/vault-connection/vault-connection.component.ts